import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F8FAFC]">
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl p-8">
        <h1 className="text-2xl font-bold text-stone-900 mb-2">Reimposta password</h1>
        <p className="text-sm text-stone-600 mb-6">Inserisci la tua email per ricevere il link di reset.</p>
        {done ? (
          <div className="bg-[#EBF8F2] text-[#1E7E55] p-4 rounded-lg text-sm">
            Se l'email è registrata, riceverai il link entro pochi minuti. Controlla anche lo spam.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email</Label><Input data-testid="forgot-email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required/></div>
            <Button type="submit" disabled={loading} className="w-full bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="forgot-submit-btn">{loading?"Invio...":"Invia link"}</Button>
          </form>
        )}
        <div className="mt-6 text-sm"><Link to="/login" className="text-[#F7941E] hover:underline">← Torna al login</Link></div>
      </div>
    </div>
  );
}
